export const NOTIFICATION_ACTION_TYPE = {
    CAPSULE: "CAPSULE",
    PRODUCT_UPTIME: "PRODUCT_UPTIME",
    PRODUCT_DOWNTIME: "PRODUCT_DOWNTIME",
    CONVERSATION: "CONVERSATION",
    BRANCH: "BRANCH",
};
